<div class="d-flex flex-column gap-3">
  <div
    class="dropzone"
    [class.dropzone--compact]="compact"
    (click)="openFileSelector()"
    (drop)="onFileDropped($event)"
    (dragover)="onDragOver($event)"
  >
    <p *ngIf="files.length === 0">
      Drop files here or click to upload.<br />
      <small *ngIf="accept">Accepted: {{ formattedAccept }}</small>
    </p>

    <div class="preview-list" *ngIf="files.length > 0">
      <div class="preview-item" *ngFor="let file of files; let i = index">
        <img
          *ngIf="previews[i]"
          [src]="previews[i]"
          alt="preview"
          class="preview-img"
        />
        <div *ngIf="!previews[i]" class="file-info">
          <span>{{ file.name }}</span>
        </div>
        <button type="button" class="remove-btn" (click)="removeFile(i); $event.stopPropagation()">
          ✖
        </button>
      </div>
    </div>

    <input
      #fileInput
      type="file"
      [attr.accept]="accept"
      [attr.multiple]="multiple ? true : null"
      (change)="onFileSelected($event)"
    />
  </div>

  <div class="text-danger" *ngIf="error">{{ error }}</div>
</div>
